export default "__VITE_ASSET__CQrK7iZC__"